import { render, staticRenderFns } from "./joinUs.vue?vue&type=template&id=1a1ac7a0&scoped=true"
import script from "./joinUs.vue?vue&type=script&lang=ts"
export * from "./joinUs.vue?vue&type=script&lang=ts"
import style0 from "./joinUs.vue?vue&type=style&index=0&id=1a1ac7a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ac7a0",
  null
  
)

export default component.exports